import React from "react";

const Dropdown = ({ className = "", children, ...props }) => {
  return (
    <select
      className={`${className}    bg-tripplo-600 
  rounded-lg 
  py-3
  px-4 
  border
  border-tripplo-300
  focus:outline-none 
  focus:bg-white`}
      {...props}
    >
      {children}
    </select>
  );
};

export default Dropdown;
